'use client';
import Snackbar from '@mui/material/Snackbar';
import classes from './style.module.scss';
import { AlertCircle, AlertClose, AlertCloseSuccess, Success } from '../../../../public/Images';
import { useWindowDimensions } from '@/hook';
import { useAppSelector } from '@/hook/redux-hooks';
import { useDispatch } from 'react-redux';
import { setToaster } from '@/redux/reducers/checkoutReducer';
import Image from 'next/image';

const Toaster = () => {
  const { width } = useWindowDimensions();
  const { flag, message, type } = useAppSelector((state) => state.checkout.toaster);
  const dispatch = useDispatch();
  const isMobileView = width <= 850;
  return (
    <Snackbar
      open={flag}
      className={`${classes.container}  ${type && classes.success}`}
      anchorOrigin={{
        vertical: isMobileView ? 'bottom' : 'top',
        horizontal: 'center',
      }}
      autoHideDuration={4000}
      onClose={() => dispatch(setToaster({ flag: false, message: message, type: type }))}
    >
      <div className={`${classes.container__innerContainer}`}>
        {type ? (
          <Image width={Success.width} height={Success.height} src={Success.src} alt="Success" />
        ) : (
          <Image
            width={AlertCircle.width}
            height={AlertCircle.height}
            src={AlertCircle.src}
            alt="alert"
          />
        )}
        <h6 className={`${type && classes.success}`}>{message}</h6>
        <button
          className={classes.container__innerContainer__closeBtn}
          onClick={() => {
            dispatch(
              setToaster({
                flag: false,
                message: message,
                type: type,
              }),
            );
          }}
        >
          {type ? (
            <Image
              width={AlertCloseSuccess.width}
              height={AlertCloseSuccess.height}
              src={AlertCloseSuccess.src}
              alt="close"
            />
          ) : (
            <Image
              width={AlertClose.width}
              height={AlertClose.height}
              src={AlertClose.src}
              alt="close"
            />
          )}
        </button>
      </div>
    </Snackbar>
  );
};

export default Toaster;
